import { authHeader } from './auth-header'
import axiosInstance from "./client"

export const supplierService = {
  fetch,
  save,
  del,
}

function fetch(id) {
  let url = '/api/v1/user/supplier'
  if (id) {
    url += '/' + id
  }
  const requestOptions = {
    url: url,
    method: 'GET',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}

function save(data) {
  const method = data["id"] != null ? "PUT" : "POST"
  const requestOptions = {
    url: `/api/v1/user/supplier`,
    method: method,
    headers: { 'Content-Type': 'application/json' },
    data: JSON.stringify(data)
  }

  return axiosInstance(requestOptions)
}


function del(id) {
  const requestOptions = {
    url: `/api/v1/user/supplier/` + id,
    method: 'DELETE',
    headers: authHeader()
  }
  return axiosInstance(requestOptions)
}

